var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "holdRuleGroupEdit"
  }, [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-card-title', {
    staticClass: "mb-3"
  }, [_vm._v(" Bewerken van groep ")])], 1)], 1), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_vm._v(" Omschrijving:"), _c('br'), _c('b-input', {
    attrs: {
      "autocomplete": "off",
      "size": "sm"
    },
    model: {
      value: _vm.localState.groupData.display_name,
      callback: function ($$v) {
        _vm.$set(_vm.localState.groupData, "display_name", $$v);
      },
      expression: "localState.groupData.display_name"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "is_active",
      "value": 1,
      "unchecked-value": 0,
      "switch": ""
    },
    model: {
      value: _vm.localState.groupData.is_active,
      callback: function ($$v) {
        _vm.$set(_vm.localState.groupData, "is_active", $$v);
      },
      expression: "localState.groupData.is_active"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Deze blokkering is actief")])])], 1)], 1), _c('b-row', {
    staticClass: "mb-1"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "is_approvable",
      "value": true,
      "unchecked-value": false,
      "switch": ""
    },
    model: {
      value: _vm.localState.isNotApprovable,
      callback: function ($$v) {
        _vm.$set(_vm.localState, "isNotApprovable", $$v);
      },
      expression: "localState.isNotApprovable"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v(" Deze blokkering kan alleen worden opgeheven door de orderdata te wijzigen "), _c('font-awesome-icon', {
    staticClass: "text-info ml-2",
    attrs: {
      "icon": "circle-info",
      "title": `Sommige hold rules controleren of alle data wel correct gevuld is. ` + `Orders met ontbrekende of verkeerd geformatteerde data kunnen verderop in het proces voor problemen zorgen. ` + `Zet deze optie bij dit soort hold rules aan dat om te voorkomen.`
    }
  })], 1)])], 1)], 1), _c('b-row', {
    staticClass: "mb-5"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "is_active",
      "value": 1,
      "unchecked-value": 0,
      "switch": ""
    },
    model: {
      value: _vm.localState.groupData.is_status_hold_final,
      callback: function ($$v) {
        _vm.$set(_vm.localState.groupData, "is_status_hold_final", $$v);
      },
      expression: "localState.groupData.is_status_hold_final"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Deze blokkering is direct definitief")])])], 1)], 1), _c('b-row', {
    staticClass: "mb-5"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('GroupRulesEdit', {
    attrs: {
      "rules": _vm.localState.groupData.hold_rules
    },
    on: {
      "removeRule": _vm.onRuleRemoval,
      "createRule": _vm.onRuleCreation
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  }), _vm._v(" Annuleren ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.dataHasChanged
    },
    on: {
      "click": _vm.confirmEdit
    }
  }, [_c('i', {
    staticClass: "fas fa-save"
  }), _vm._v(" Opslaan ")])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }